module.exports = __webpack_public_path__ + "assets/78aff441a538e377745611cb706da4c2.mp3";